<template>
  <div>
    <label :class="{ 'sr-only': hide_label }" :for="'input-' + id">{{ text }}</label>
    <date-picker
      v-model="value"
      :id="'input-' + id"
      :placeholder="text"
      :config="config"
    />
  </div>
</template>

<script>
export default {
  name: 'InputDate',
  props: ['val', 'id', 'text', 'config', 'hide_label'],
  data () {
    return {
      value: this.val
    }
  },
  watch: {
    value: function () {
      this.$emit('passToParent', this.id, this.value)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/templates/InputDate/InputDate.vue